<mon-page-layout [header]="getPageHeader()" [formLayout]="'single-column'">
    <form #form="ngForm" class="admin-performance-profile-form" data-test="admin-performance-profile-form">
        <div>
            <p-card>
                <ng-template #title>
                    <h2 class="form-header tw-mt-0 tw-mb-2">{{'adminPerformanceProfiles.addEdit.form.header' | transloco }}</h2>
                    <p class="form-subheader tw-my-0">{{'adminPerformanceProfiles.addEdit.form.subHeader' | transloco }}</p>
                </ng-template>
                <div class="tw-mb-4">
                    <label for="profile-name" class="form-label">{{'adminPerformanceProfiles.addEdit.form.nameLabel' | transloco }}*</label>
                    <input
                        type="text"
                        pInputText
                        fluid
                        [placeholder]="'adminPerformanceProfiles.addEdit.form.namePlaceholder' | transloco"
                        [(ngModel)]="profile.name"
                        name="profile-name"
                        id="profile-name"
                        required
                        #profileName="ngModel"
                        data-test="admin-performance-profile-name-input"
                    />
                    <small *ngIf="profileName.invalid && profileName.touched" class="tw-text-red-500 tw-text-sm">
                        {{ 'adminPerformanceProfiles.addEdit.form.nameRequired' | transloco }}
                    </small>
                </div>
                <div class="tw-mb-4">
                    <label for="profile-description" class="form-label">{{'adminPerformanceProfiles.addEdit.form.descriptionLabel' | transloco }}</label>
                    <input
                        type="text"
                        pInputText
                        fluid
                        [placeholder]="'adminPerformanceProfiles.addEdit.form.descriptionPlaceholder' | transloco"
                        [(ngModel)]="profile.description"
                        name="profile-description"
                        id="profile-description"
                        data-test="admin-performance-profile-description-input" />
                </div>
                <div class="tw-mb-4">
                    <label for="profile-device" class="form-label">{{'adminPerformanceProfiles.addEdit.form.deviceLabel' | transloco }}*</label>
                    <div>
                        <p-select
                            [options]="deviceOptions"
                            fluid
                            [(ngModel)]="profile.device"
                            name="profile-device"
                            id="profile-device"
                            [disabled]="isEditMode"
                            [placeholder]="'adminPerformanceProfiles.addEdit.form.devicePlaceholder' | transloco"
                            required
                            #profileDevice="ngModel"
                            data-test="admin-performance-profile-device-select">
                            <ng-template #item #selectedItem let-option>
                                <div class="inline-block">
                                    <i class="{{option.icon}}"></i>
                                    <span class="ml-1 text-ellipsis">
                                        {{option.label}}
                                    </span>
                                </div>
                            </ng-template>
                        </p-select>
                        <small *ngIf="profileDevice.invalid && profileDevice.touched" class="tw-text-red-500 tw-text-sm">
                            {{ 'adminPerformanceProfiles.addEdit.form.deviceRequired' | transloco }}
                        </small>
                    </div>
                    <small>{{'adminPerformanceProfiles.addEdit.form.lockedAfterSave' | transloco}}</small>
                </div>
                <div class="tw-mb-4">
                    <label for="profile-connection" class="form-label">{{'adminPerformanceProfiles.addEdit.form.connectionProfileLabel' | transloco }}*</label>
                    <div>
                        <p-select
                            [options]="connectionProfiles"
                            optionLabel="name"
                            optionValue="name"
                            fluid
                            [(ngModel)]="currentConnectionProfile"
                            [disabled]="isEditMode"
                            name="profile-connection"
                            id="profile-connection"
                            required
                            #profileConnection="ngModel"
                            data-test="admin-performance-profile-connection-input"
                            [placeholder]="'adminPerformanceProfiles.addEdit.form.connectionProfilePlaceholder' | transloco" />
                        <small *ngIf="profileConnection.invalid && profileConnection.touched" class="tw-text-red-500 tw-text-sm">
                            {{ 'adminPerformanceProfiles.addEdit.form.connectionProfileRequired' | transloco }}
                        </small>
                    </div>
                    <small>{{'adminPerformanceProfiles.addEdit.form.lockedAfterSave' | transloco}}</small>
                </div>
                <div>
                    <label for="profile-measure" class="form-label">{{'adminPerformanceProfiles.addEdit.form.measureFromLabel' | transloco }}*</label>
                    <div>
                        <p-select
                            [options]="locationOptions"
                            optionValue="key"
                            fluid
                            [(ngModel)]="currentLocation"
                            [disabled]="isEditMode"
                            name="profile-measure"
                            id="profile-measure"
                            required
                            #profileMeasure="ngModel"
                            data-test="admin-performance-profile-measure-input"
                            [placeholder]="'adminPerformanceProfiles.addEdit.form.measureFromPlaceholder' | transloco">
                            <ng-template #item #selectedItem let-option>
                                <div class="inline-block">
                                    <span class="ml-1 text-ellipsis">
                                        {{option.country}}: {{ option.city }}
                                    </span>
                                </div>
                            </ng-template>
                        </p-select>
                        <small *ngIf="profileMeasure.invalid && profileMeasure.touched" class="tw-text-red-500 tw-text-sm">
                                {{ 'adminPerformanceProfiles.addEdit.form.measureFromRequired' | transloco }}
                        </small>
                    </div>
                    <small>{{'adminPerformanceProfiles.addEdit.form.lockedAfterSave' | transloco}}</small>
                </div>
            </p-card>
        </div>
        <div class="form-actions">
            <p-button
                severity="primary"
                variant="text"
                [label]="'adminPerformanceProfiles.addEdit.form.cancelButtonLabel' | transloco"
                (onClick)="close()"
                data-test="admin-performance-profile-cancel-button"
            />
            <p-button
                severity="primary"
                [label]="'adminPerformanceProfiles.addEdit.form.saveButtonLabel' | transloco"
                (onClick)="saveProfile()"
                [disabled]="saving || form.invalid"
                class="tw-ml-4"
                data-test="admin-performance-profile-save-button"
            />
        </div>
    </form>
</mon-page-layout>
